import { PAGE_CRASH_MAX_AUTO_RELOAD_ATTEMPTS, STORAGE_KEY } from "@constants";
import { stringifyError } from "@utils/misc";
import { safeSessionGetItem } from "@utils/storage";
import { CrashFlowState } from "./types";

export const isCacheRelatedError = (error: unknown): boolean => {
  const text = stringifyError(error).toLowerCase();

  return (
    text.includes("chunkloaderror") ||
    text.includes("unable to preload css") ||
    text.includes("css chunk load failed") ||
    text.includes("loading chunk") ||
    text.includes("failed to fetch dynamically imported module") ||
    text.includes("error loading dynamically imported module") ||
    text.includes("dynamically imported module") ||
    text.includes("importing a module script failed") ||
    text.includes("failed to load module script") ||
    (text.includes("unexpected token '<'") && (text.includes(".js") || text.includes("chunk"))) ||
    (text.includes("mime type") && text.includes("script") && (text.includes(".js") || text.includes("module")))
  );
};

export const getCrashFlowState = (error?: unknown): CrashFlowState => {
  const reloadCount = Number.parseInt(safeSessionGetItem(STORAGE_KEY.PAGE_CRASH_AUTO_RELOAD_COUNT) ?? "0", 10) || 0;
  const isAutoReloadCandidate = Boolean(error) && isCacheRelatedError(error);

  return {
    canAutoReload: isAutoReloadCandidate && reloadCount < PAGE_CRASH_MAX_AUTO_RELOAD_ATTEMPTS,
    isAutoReloadCandidate,
    reloadCount,
  };
};
